import {
  SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST,
  SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_SUCCESS,
  SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_FAIL,
  CREATE_OPPORTUNITIES_ITEM,
  CREATE_OPPORTUNITIES_ITEM_SUCCESS,
  CREATE_OPPORTUNITIES_ITEM_FAIL,
  UPDATE_OPPORTUNITIES_ITEM,
  UPDATE_OPPORTUNITIES_ITEM_SUCCESS,
  UPDATE_OPPORTUNITIES_ITEM_FAIL,
  GET_ALL_OPPORTUNITIES_LIST,
  GET_ALL_OPPORTUNITIES_LIST_SUCCESS,
  GET_ALL_OPPORTUNITIES_LIST_FAIL,
  GET_SINGLE_OPPORTUNITIES_ITEM,
  GET_SINGLE_OPPORTUNITIES_ITEM_SUCCESS,
  GET_SINGLE_OPPORTUNITIES_ITEM_FAIL,
  DELETE_OPPORTUNITIES_ITEM,
  DELETE_OPPORTUNITIES_ITEM_SUCCESS,
  DELETE_OPPORTUNITIES_ITEM_FAIL,
  OPPORTUNITIES_STATUS_LIST,
  OPPORTUNITIES_STATUS_LIST_SUCCESS,
  OPPORTUNITIES_STATUS_LIST_FAIL,
  OPPORTUNITIES_PRIORITY_LIST,
  OPPORTUNITIES_PRIORITY_LIST_SUCCESS,
  OPPORTUNITIES_PRIORITY_LIST_FAIL,
  OPPORTUNITIES_TYPE_LIST,
  OPPORTUNITIES_TYPE_LIST_SUCCESS,
  OPPORTUNITIES_TYPE_LIST_FAIL,
  GET_SINGLE_OPPORTUNITY_DATA,
  GET_SINGLE_OPPORTUNITY_DATA_SUCCESS,
  GET_SINGLE_OPPORTUNITY_DATA_FAIL,
  SEARCH_OPPORTUNITY_NOTE_LIST,
  SEARCH_OPPORTUNITY_NOTE_LIST_SUCCESS,
  SEARCH_OPPORTUNITY_NOTE_LIST_FAIL,
  CREATE_OPPORTUNITY_NOTE_ITEM,
  CREATE_OPPORTUNITY_NOTE_ITEM_SUCCESS,
  CREATE_OPPORTUNITY_NOTE_ITEM_FAIL,
  SINGLE_OPPORTUNITY_ACTIVITY_LIST,
  SINGLE_OPPORTUNITY_ACTIVITY_LIST_SUCCESS,
  SINGLE_OPPORTUNITY_ACTIVITY_LIST_FAIL,
  ADD_NEW_OPPORTUNITY_STATUS,
  ADD_NEW_OPPORTUNITY_STATUS_SUCCESS,
  ADD_NEW_OPPORTUNITY_STATUS_FAIL,
  DELETE_OPPORTUNITY_STATUS,
  DELETE_OPPORTUNITY_STATUS_SUCCESS,
  DELETE_OPPORTUNITY_STATUS_FAIL,
  UPDATE_OPPORTUNITY_STATUS,
  UPDATE_OPPORTUNITY_STATUS_SUCCESS,
  UPDATE_OPPORTUNITY_STATUS_FAIL,
  ADD_NEW_OPPORTUNITY_PRIORITY,
  ADD_NEW_OPPORTUNITY_PRIORITY_SUCCESS,
  ADD_NEW_OPPORTUNITY_PRIORITY_FAIL,
  DELETE_OPPORTUNITY_PRIORITY,
  DELETE_OPPORTUNITY_PRIORITY_SUCCESS,
  DELETE_OPPORTUNITY_PRIORITY_FAIL,
  UPDATE_OPPORTUNITY_PRIORITY,
  UPDATE_OPPORTUNITY_PRIORITY_SUCCESS,
  UPDATE_OPPORTUNITY_PRIORITY_FAIL,
  ADD_NEW_OPPORTUNITY_TYPE,
  ADD_NEW_OPPORTUNITY_TYPE_SUCCESS,
  ADD_NEW_OPPORTUNITY_TYPE_FAIL,
  DELETE_OPPORTUNITY_TYPE,
  DELETE_OPPORTUNITY_TYPE_SUCCESS,
  DELETE_OPPORTUNITY_TYPE_FAIL,
  UPDATE_OPPORTUNITY_TYPE,
  UPDATE_OPPORTUNITY_TYPE_SUCCESS,
  UPDATE_OPPORTUNITY_TYPE_FAIL,
  GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA,
  GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_SUCCESS,
  GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_FAIL,
  SEARCH_OPPORTUNITY_ATTACHMENT_LIST,
  SEARCH_OPPORTUNITY_ATTACHMENT_LIST_SUCCESS,
  SEARCH_OPPORTUNITY_ATTACHMENT_LIST_FAIL,
  DELETE_OPPORTUNITY_ATTACHMENT,
  DELETE_OPPORTUNITY_ATTACHMENT_SUCCESS,
  DELETE_OPPORTUNITY_ATTACHMENT_FAIL,
  SEARCH_OPPORTUNITY_PRODUCT_LIST,
  SEARCH_OPPORTUNITY_PRODUCT_LIST_SUCCESS,
  SEARCH_OPPORTUNITY_PRODUCT_LIST_FAIL,
  CREATE_OPPORTUNITY_PRODUCT_ITEM,
  CREATE_OPPORTUNITY_PRODUCT_ITEM_SUCCESS,
  CREATE_OPPORTUNITY_PRODUCT_ITEM_FAIL,
  DELETE_OPPORTUNITY_PRODUCT_ITEM,
  DELETE_OPPORTUNITY_PRODUCT_ITEM_SUCCESS,
  DELETE_OPPORTUNITY_PRODUCT_ITEM_FAIL,
} from "./actionType";

// Opportunity Reducer

const initialState = {
  searchSingleCustomerOpportunitiesList: [],
  createOpportunitiesItem: [],
  updateOpportunitiesItem: [],
  getAllOpportunitiesList: [],
  getSingleOpportunitiesItem: [],
  deleteOpportunitiesItem: [],
  opportunitiesStatusList: [],
  opportunitiesPriorityList: [],
  opportunitiesTypeList: [],
  SingleOpportunityData: [],
  searchOpportunityNoteList: [],
  createOpportunityNoteItemSuccess: [],
  singleOpportunityActivityList: [],
  ListDataLoading: false,
  updateOpportunitiesItemSuccess: [],
  updateOpportunitiesItemSuccessLoading: false,
  deleteOpportunitiesItemSuccess: [],
  createOpportunitiesItemSuccess: [],
  createOpportunitiesItemSuccessLoading: false,
  addNewOpportunityStatusSuccess: [],
  deleteOpportunityStatusSuccess: [],
  updateOpportunityStatusSuccess: [],
  updateOpportunityStatusSuccessLoading: false,
  addNewOpportunityPrioritySuccess: [],
  deleteOpportunityPrioritySuccess: [],
  updateOpportunityPrioritySuccess: [],
  addNewOpportunityTypeSuccess: [],
  deleteOpportunityTypeSuccess: [],
  updateOpportunityTypeSuccess: [],

  getOpportunityOverviewFunnelData: [],
  getOpportunityOverviewFunnelDataLoading: false,

  opportunityAttachmentSearchList: [],
  opportunityAttachmentSearchListLoading: false,
  deleteOpportunityAttachmentSuccess: [],
  deleteOpportunityAttachmentLoading: false,

  opportunityProductSearchList: [],
  opportunityProductSearchListLoading: false,
  createOpportunityProductItemSuccess: [],
  createOpportunityProductItemLoading: false,
  deleteOpportunityProductItemSuccess: [],
  deleteOpportunityProductItemLoading: false,
};

export default function Opportunities(state = initialState, action) {
  switch (action.type) {
    case SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST:
      return {
        ...state,
        ListDataLoading: true,
      };
    case SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_SUCCESS:
      return {
        ...state,
        searchSingleCustomerOpportunitiesList: action.payload,
        ListDataLoading: false,
      };
    case SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_FAIL:
      return {
        ...state,
        searchSingleCustomerOpportunitiesList: action.payload,
        ListDataLoading: false,
      };
    case CREATE_OPPORTUNITIES_ITEM:
      return {
        ...state,
        createOpportunitiesItem: action.payload,
      };
    case CREATE_OPPORTUNITIES_ITEM_SUCCESS:
      return {
        ...state,
        createOpportunitiesItemSuccess: action.payload,
      };
    case CREATE_OPPORTUNITIES_ITEM_FAIL:
      return {
        ...state,
        createOpportunitiesItem: action.payload,
      };
    case UPDATE_OPPORTUNITIES_ITEM:
      return {
        ...state,
        updateOpportunitiesItem: action.payload,
      };
    case UPDATE_OPPORTUNITIES_ITEM_SUCCESS:
      return {
        ...state,
        updateOpportunitiesItemSuccess: action.payload,
      };
    case UPDATE_OPPORTUNITIES_ITEM_FAIL:
      return {
        ...state,
        updateOpportunitiesItem: action.payload,
      };
    case GET_ALL_OPPORTUNITIES_LIST:
      return {
        ...state,
        getAllOpportunitiesList: action.payload,
        ListDataLoading: true,
      };
    case GET_ALL_OPPORTUNITIES_LIST_SUCCESS:
      return {
        ...state,
        getAllOpportunitiesList: action.payload,
        ListDataLoading: false,
      };
    case GET_ALL_OPPORTUNITIES_LIST_FAIL:
      return {
        ...state,
        getAllOpportunitiesList: action.payload,
        ListDataLoading: false,
      };
    case GET_SINGLE_OPPORTUNITIES_ITEM:
      return {
        ...state,
        getSingleOpportunitiesItem: action.payload,
      };
    case GET_SINGLE_OPPORTUNITIES_ITEM_SUCCESS:
      return {
        ...state,
        getSingleOpportunitiesItem: action.payload,
      };
    case GET_SINGLE_OPPORTUNITIES_ITEM_FAIL:
      return {
        ...state,
        getSingleOpportunitiesItem: action.payload,
      };
    case DELETE_OPPORTUNITIES_ITEM:
      return {
        ...state,
      };

    case DELETE_OPPORTUNITIES_ITEM_SUCCESS:
      return {
        ...state,
        deleteOpportunitiesItemSuccess: action.payload,
      };

    case DELETE_OPPORTUNITIES_ITEM_FAIL:
      return {
        ...state,
        deleteOpportunitiesItem: action.payload,
      };
    case OPPORTUNITIES_STATUS_LIST:
      return {
        ...state,
      };
    case OPPORTUNITIES_STATUS_LIST_SUCCESS:
      return {
        ...state,
        opportunitiesStatusList: action.payload,
      };
    case OPPORTUNITIES_STATUS_LIST_FAIL:
      return {
        ...state,
        opportunitiesStatusList: action.payload,
      };
    case OPPORTUNITIES_PRIORITY_LIST:
      return {
        ...state,
      };
    case OPPORTUNITIES_PRIORITY_LIST_SUCCESS:
      return {
        ...state,
        opportunitiesPriorityList: action.payload,
      };
    case OPPORTUNITIES_PRIORITY_LIST_FAIL:
      return {
        ...state,
        opportunitiesPriorityList: action.payload,
      };
    case OPPORTUNITIES_TYPE_LIST:
      return {
        ...state,
      };
    case OPPORTUNITIES_TYPE_LIST_SUCCESS:
      return {
        ...state,
        opportunitiesTypeList: action.payload,
      };
    case OPPORTUNITIES_TYPE_LIST_FAIL:
      return {
        ...state,
        opportunitiesTypeList: action.payload,
      };
    case GET_SINGLE_OPPORTUNITY_DATA:
      return {
        ...state,
      };
    case GET_SINGLE_OPPORTUNITY_DATA_SUCCESS:
      return {
        ...state,
        SingleOpportunityData: action.payload,
      };
    case GET_SINGLE_OPPORTUNITY_DATA_FAIL:
      return {
        ...state,
        SingleOpportunityData: action.payload,
      };
    case SEARCH_OPPORTUNITY_NOTE_LIST:
      return {
        ...state,
      };
    case SEARCH_OPPORTUNITY_NOTE_LIST_SUCCESS:
      return {
        ...state,
        searchOpportunityNoteList: action.payload,
      };
    case SEARCH_OPPORTUNITY_NOTE_LIST_FAIL:
      return {
        ...state,
        searchOpportunityNoteList: action.payload,
      };
    case CREATE_OPPORTUNITY_NOTE_ITEM:
      return {
        ...state,
      };
    case CREATE_OPPORTUNITY_NOTE_ITEM_SUCCESS:
      return {
        ...state,
        createOpportunityNoteItemSuccess: action.payload,
      };
    case CREATE_OPPORTUNITY_NOTE_ITEM_FAIL:
      return {
        ...state,
        createOpportunityNoteItemSuccess: action.payload,
      };
    case SINGLE_OPPORTUNITY_ACTIVITY_LIST:
      return {
        ...state,
      };
    case SINGLE_OPPORTUNITY_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        singleOpportunityActivityList: action.payload,
      };
    case SINGLE_OPPORTUNITY_ACTIVITY_LIST_FAIL:
      return {
        ...state,
        singleOpportunityActivityList: action.payload,
      };
    case ADD_NEW_OPPORTUNITY_STATUS:
      return {
        ...state,
      };
    case ADD_NEW_OPPORTUNITY_STATUS_SUCCESS:
      return {
        ...state,
        addNewOpportunityStatusSuccess: action.payload,
      };
    case ADD_NEW_OPPORTUNITY_STATUS_FAIL:
      return {
        ...state,
        addNewOpportunityStatusSuccess: action.payload,
      };
    case DELETE_OPPORTUNITY_STATUS:
      return {
        ...state,
      };
    case DELETE_OPPORTUNITY_STATUS_SUCCESS:
      return {
        ...state,
        deleteOpportunityStatusSuccess: action.payload,
      };
    case DELETE_OPPORTUNITY_STATUS_FAIL:
      return {
        ...state,
        deleteOpportunityStatusSuccess: action.payload,
      };
    case UPDATE_OPPORTUNITY_STATUS:
      return {
        ...state,
      };
    case UPDATE_OPPORTUNITY_STATUS_SUCCESS:
      return {
        ...state,
        updateOpportunityStatusSuccess: action.payload,
      };
    case UPDATE_OPPORTUNITY_STATUS_FAIL:
      return {
        ...state,
        updateOpportunityStatusSuccess: action.payload,
      };
    case ADD_NEW_OPPORTUNITY_PRIORITY:
      return {
        ...state,
      };
    case ADD_NEW_OPPORTUNITY_PRIORITY_SUCCESS:
      return {
        ...state,
        addNewOpportunityPrioritySuccess: action.payload,
      };
    case ADD_NEW_OPPORTUNITY_PRIORITY_FAIL:
      return {
        ...state,
        addNewOpportunityPrioritySuccess: action.payload,
      };
    case DELETE_OPPORTUNITY_PRIORITY:
      return {
        ...state,
      };
    case DELETE_OPPORTUNITY_PRIORITY_SUCCESS:
      return {
        ...state,
        deleteOpportunityPrioritySuccess: action.payload,
      };
    case DELETE_OPPORTUNITY_PRIORITY_FAIL:
      return {
        ...state,
      };
    case UPDATE_OPPORTUNITY_PRIORITY:
      return {
        ...state,
      };
    case UPDATE_OPPORTUNITY_PRIORITY_SUCCESS:
      return {
        ...state,
        updateOpportunityPrioritySuccess: action.payload,
      };
    case UPDATE_OPPORTUNITY_PRIORITY_FAIL:
      return {
        ...state,
      };
    case ADD_NEW_OPPORTUNITY_TYPE:
      return {
        ...state,
      };
    case ADD_NEW_OPPORTUNITY_TYPE_SUCCESS:
      return {
        ...state,
        addNewOpportunityTypeSuccess: action.payload,
      };
    case ADD_NEW_OPPORTUNITY_TYPE_FAIL:
      return {
        ...state,
      };
    case DELETE_OPPORTUNITY_TYPE:
      return {
        ...state,
      };
    case DELETE_OPPORTUNITY_TYPE_SUCCESS:
      return {
        ...state,
        deleteOpportunityTypeSuccess: action.payload,
      };
    case DELETE_OPPORTUNITY_TYPE_FAIL:
      return {
        ...state,
      };
    case UPDATE_OPPORTUNITY_TYPE:
      return {
        ...state,
      };
    case UPDATE_OPPORTUNITY_TYPE_SUCCESS:
      return {
        ...state,
        updateOpportunityTypeSuccess: action.payload,
      };
    case UPDATE_OPPORTUNITY_TYPE_FAIL:
      return {
        ...state,
      };
    case GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA:
      return {
        ...state,
        getOpportunityOverviewFunnelDataLoading: true,
      };
    case GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_SUCCESS:
      return {
        ...state,
        getOpportunityOverviewFunnelData: action.payload,
        getOpportunityOverviewFunnelDataLoading: false,
      };
    case GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_FAIL:
      return {
        ...state,
        getOpportunityOverviewFunnelData: action.payload,
        getOpportunityOverviewFunnelDataLoading: false,
      };
    case SEARCH_OPPORTUNITY_ATTACHMENT_LIST:
      return {
        ...state,
        opportunityAttachmentSearchListLoading: true,
      };
    case SEARCH_OPPORTUNITY_ATTACHMENT_LIST_SUCCESS:
      return {
        ...state,
        opportunityAttachmentSearchList: action.payload,
        opportunityAttachmentSearchListLoading: false,
      };
    case SEARCH_OPPORTUNITY_ATTACHMENT_LIST_FAIL:
      return {
        ...state,
        opportunityAttachmentSearchList: action.payload,
        opportunityAttachmentSearchListLoading: false,
      };
    case DELETE_OPPORTUNITY_ATTACHMENT:
      return {
        ...state,
        deleteOpportunityAttachmentLoading: true,
      };
    case DELETE_OPPORTUNITY_ATTACHMENT_SUCCESS:
      return {
        ...state,
        deleteOpportunityAttachmentSuccess: action.payload,
        deleteOpportunityAttachmentLoading: false,
      };
    case DELETE_OPPORTUNITY_ATTACHMENT_FAIL:
      return {
        ...state,
        deleteOpportunityAttachmentSuccess: action.payload,
        deleteOpportunityAttachmentLoading: false,
      };

    case SEARCH_OPPORTUNITY_PRODUCT_LIST:
      return {
        ...state,
        opportunityProductSearchListLoading: true,
      };
    case SEARCH_OPPORTUNITY_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        opportunityProductSearchList: action.payload,
        opportunityProductSearchListLoading: false,
      };
    case SEARCH_OPPORTUNITY_PRODUCT_LIST_FAIL:
      return {
        ...state,
        opportunityProductSearchList: action.payload,
        opportunityProductSearchListLoading: false,
      };
    case CREATE_OPPORTUNITY_PRODUCT_ITEM:
      return {
        ...state,
        createOpportunityProductItemLoading: true,
      };
    case CREATE_OPPORTUNITY_PRODUCT_ITEM_SUCCESS:
      return {
        ...state,
        createOpportunityProductItemSuccess: action.payload,
        createOpportunityProductItemLoading: false,
      };
    case CREATE_OPPORTUNITY_PRODUCT_ITEM_FAIL:
      return {
        ...state,
        createOpportunityProductItemSuccess: action.payload,
        createOpportunityProductItemLoading: false,
      };
    case DELETE_OPPORTUNITY_PRODUCT_ITEM:
      return {
        ...state,
        deleteOpportunityProductItemLoading: true,
      };
    case DELETE_OPPORTUNITY_PRODUCT_ITEM_SUCCESS:
      return {
        ...state,
        deleteOpportunityProductItemSuccess: action.payload,
        deleteOpportunityProductItemLoading: false,
      };
    case DELETE_OPPORTUNITY_PRODUCT_ITEM_FAIL:
      return {
        ...state,
        deleteOpportunityProductItemSuccess: action.payload,
        deleteOpportunityProductItemLoading: false,
      };

    default:
      return state;
  }
}
